import {get} from "../../api/api";
import {WS} from "./ws";

interface SttSession {
    clientId: string;
    sessionId: string;
}

interface TranscriptMessage {
    type: string;
    utterance?: {
        id: string;
        sentence: string;
        words: Array<{ word: string; start: number; end: number }>;
    };
    completed?: boolean;
}

export class JuvolyWS extends WS {
    private sessionId: string | null = null;
    public readonly name: string = 'Juvoly';

    constructor(
        private language: string,
    ) {
        super();
    }

    async createConnection() {
        const session = await get<SttSession>("/session/juvoly");
        this.sessionId = session.sessionId;

        const model = "juvoly_v3";
        const juvolyUrl = `wss://services.juvoly.nl/api/v2/socket/${model}?languages=${this.language}`;

        console.info(`Connecting to [JuvolyWS] (${this.sessionId}):`, juvolyUrl);

        this.socket = new WebSocket(juvolyUrl, ["v2.juvoly", session.clientId, this.sessionId]);
        this.socket.binaryType = "arraybuffer";
        await new Promise<void>((resolve, reject) => {
            this.socket!.onclose = (event) => {
                const message = `[JuvolyWS] closed. Code=${event.code}`;
                console.info(message);
                if (event.code !== 1000 && event.code !== 1005) {
                    this.close();
                    this.handleError(message)
                    reject(new Error(message));
                }
            };

            this.socket!.onerror = (error) => {
                this.handleError(`${error}`)
                reject(error);
            };

            this.socket!.onmessage = (event) => {
                console.info('[JuvolyWS] Event:', event)

                try {
                    const data: TranscriptMessage = JSON.parse(event.data);

                    if (data.type === "ready") {
                        console.info(`[JuvolyWS] ready (${this.sessionId})`);
                        resolve();
                    } else if (data.type === "transcript" && data.utterance) {
                        this.handleTranscript(data.utterance.sentence, data.completed ?? false);
                    }
                } catch (e) {
                    console.warn(`[GoogleSpeechWS] invalid message:`, event.data);
                }
            };
        });
    }
}
